export default class VideoTopic {
    public id: string;
    public normalizedName: string;
    public sortOrder: number;
    public localizedName: string;
    public unratedVideoCount: number;

    constructor(json: any) {
        this.id = json.id;
        this.normalizedName = json.normalizedName;
        this.sortOrder = json.sortOrder;
        this.localizedName = json.localizedName;
        this.unratedVideoCount = json.unratedVideoCount;
    }
}
